import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SplashScreen} from '@capacitor/splash-screen';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.initializeTranslate();
    SplashScreen.hide();
  }


  private initializeTranslate() {
    this.translate.use('en');
  }
}
